import * as React from "react";
import brandLogo from "../assets/brand-logo.png";

export default class EmailValidado extends React.Component {

    render() {
        return (
            <React.Fragment>
                <form id="resetpassword" className="backlogin h-100vh w-100">
                    <div className="login-title">
                        <img className="brand-logo mb-0" src={brandLogo} alt="brand-logo" />
                    </div> 
                    <div id="reset-form">
                        <h4 style={{fontSize: '1.5rem'}}> Validar Email</h4>
                        <br />
                        <div className="d-flex justify-content-center mx-auto"
                            style={{ lineHeight: "20px", fontSize: '14px' }}>
                            Su email ha sido validado. 
                        </div>
                        <div className="d-flex justify-content-center mx-auto"
                            style={{ lineHeight: "20px", fontSize: '14px' }}>
                            Haga click &nbsp;<a onClick={() => {
                                window.location = window.location.origin + "/";
                            }} style={{textDecoration: 'underline', cursor: 'pointer'}}> aqui</a>&nbsp; para iniciar sesi&oacute;n.
                        </div>
                    </div>
                </form>
            </React.Fragment>
        )
    }
}